// extracted by mini-css-extract-plugin
export default {"control":"TextAndColorInput_control__lhXGe","field":"TextAndColorInput_field__8nrwF Input_field__xPT0l","color":"TextAndColorInput_color__Z23FD"};